export interface Skill {
  id: string;
  labelKey: string;
  icon: string;
  category: 'life' | 'tech' | 'ai';
  descriptionKey?: string;
}

export const skills: Skill[] = [
  // Life Skills
  {
    id: 'prompt',
    labelKey: 'thoughts.prompt',
    icon: '🧠',
    category: 'life',
    descriptionKey: 'skills.desc.prompt',
  },
  {
    id: 'agri',
    labelKey: 'thoughts.agri',
    icon: '🌱',
    category: 'life',
    descriptionKey: 'skills.desc.agri',
  },
  {
    id: 'drone',
    labelKey: 'thoughts.drone',
    icon: '🚁',
    category: 'life',
    descriptionKey: 'skills.desc.drone',
  },
  {
    id: 'sales',
    labelKey: 'thoughts.sales',
    icon: '🤝',
    category: 'life',
    descriptionKey: 'skills.desc.sales',
  },
  {
    id: 'hockey',
    labelKey: 'thoughts.hockey',
    icon: '🏒',
    category: 'life',
    descriptionKey: 'skills.desc.hockey',
  },
  {
    id: 'skating',
    labelKey: 'thoughts.skating',
    icon: '⛸️',
    category: 'life',
    descriptionKey: 'skills.desc.skating',
  },
  // Technical Skills
  {
    id: 'react',
    labelKey: 'thoughts.react',
    icon: '⚛️',
    category: 'tech',
    descriptionKey: 'skills.desc.react',
  },
  {
    id: 'python',
    labelKey: 'thoughts.python',
    icon: '🐍',
    category: 'tech',
    descriptionKey: 'skills.desc.python',
  },
  {
    id: 'web',
    labelKey: 'thoughts.web',
    icon: '🌐',
    category: 'tech',
    descriptionKey: 'skills.desc.web',
  },
  {
    id: 'php',
    labelKey: 'thoughts.php',
    icon: '🐘',
    category: 'tech',
    descriptionKey: 'skills.desc.php',
  },
  {
    id: 'git',
    labelKey: 'thoughts.git',
    icon: '📦',
    category: 'tech',
    descriptionKey: 'skills.desc.git',
  },
  // AI & Modern Stack
  {
    id: 'ai',
    labelKey: 'thoughts.ai',
    icon: '🤖',
    category: 'ai',
    descriptionKey: 'skills.desc.ai',
  },
  {
    id: 'mcp',
    labelKey: 'thoughts.mcp',
    icon: '🔗',
    category: 'ai',
    descriptionKey: 'skills.desc.mcp',
  },
];

export const skillCategories = [
  { id: 'life', labelKey: 'skills.categories.life', color: '#00ff88' },
  { id: 'tech', labelKey: 'skills.categories.tech', color: '#00d4ff' },
  { id: 'ai', labelKey: 'skills.categories.ai', color: '#ff6b35' },
];